import React from "react";
import loading from "../../assets/images/loading.gif";

const Loading = (props) => {
    const {sizeDigit, className} = props;
    const loads = [];
    for (let i = 0; i < sizeDigit; i++) {
        loads.push(<img alt="" key={i} src={loading} className={className}/>);
    }
    return loads;
}
export default Loading;